import React, { useState, createContext, useEffect, useContext } from 'react';
import axios from '../Util/axiosConfig';
// url
import { baseUrl } from '../Contants';
import { AppContext } from './AppContextProvide';
export const ProductContext = createContext();
export const ProductContextProvider = ({ children }) => {
  const { user, isLoggedOut } = useContext(AppContext);
  const [product, setProduct] = useState({});
  const [path, setPath] = useState('');
  const [update, setUpdate] = useState(false);
  const [productDisclaimer, setProductDisclaimer] = useState('');
  const [taxDisclaimer, setTaxDisclaimer] = useState('');
  const [progress, setProgress] = useState(true); 

  useEffect(() => {
    async function getProductDetails(productUrl) {
      await axios.get(`${productUrl}`).then((result) => {
          setProduct(result.data.data[0] ?? {});
        })
        .catch((err) => {
          if (['401', '500'].includes(err.status)) {
            console.log(err);
            localStorage.clear();
            sessionStorage.clear();
            setProgress(false);
          } else {
            console.log(err);
          }
        });
    }

    async function getProductDisclaimer() {
      const result = await axios.get(`${baseUrl}/api/admin/disclaimer/product`);
      setProductDisclaimer(result.data.data[0].product_disclaimer);
    }

    async function getTaxDisclaimer() {
      const result = await axios.get(`${baseUrl}/api/admin/taxdisclaimer`);
      setTaxDisclaimer(result.data.data[0].disclaimer);
    }

    let productUrl;

    if (!isLoggedOut && user?.access_type_cd !== 'c') {
      productUrl = `${baseUrl}/api/user/product/${path}`;
    } else {
      productUrl = `${baseUrl}/api/product/${path}`;
    }
  

    if (path) {
      getTaxDisclaimer();
      getProductDisclaimer();
      getProductDetails(productUrl)
      setUpdate(false);
    }
  }, [path, update, user?.access_type_cd, isLoggedOut]);
  return (
    <ProductContext.Provider
      value={{
        product,
        productDisclaimer,
        taxDisclaimer,
        progress,
        setPath,
        setUpdate,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
